"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Backbone = _interopRequireDefault(require("Backbone"));

var _RouterContainer = _interopRequireDefault(require("crm_internal/containers/RouterContainer"));

var _getPathname = _interopRequireDefault(require("crm_internal/utils/getPathname"));

var _default = function _default(router) {
  _RouterContainer.default.set(router);

  if (window && window.performance && window.performance.mark) {
    window.performance.mark('mark_router_start');
  }

  router.on('route', function (route) {
    _Backbone.default.history.currentRoute = route;
    window.scrollTo(0, 0);
  });

  var matchedRoute = _Backbone.default.history.start({
    pushState: true,
    root: (0, _getPathname.default)()
  });

  return matchedRoute || router.showErrorPage(404);
};

exports.default = _default;
module.exports = exports.default;